import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import FormField from '../layout/FormField';
import FormSelect from '../layout/FormSelect';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ReactSelect from 'react-select';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { toast } from 'react-toastify';
import { useAuth } from '../../hooks/useAuth';
import moment from 'moment';
import ProvinceData from '../../constants/ProvinceData';
import { getCities } from '../../helpers/utils';
const customStyles = {
    input: (provided, state) => ({
        ...provided,
        // color: '#29cfb1',
        padding: '5px 0px'
    }),
    placeholder: (provided, state) => ({
        ...provided,
        color: '#ced4da'
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        marginLeft: 5
    }),
    menuList: (provided, state) => ({
        ...provided,
        fontSize: 14,
        color: '#a4a4a4'
    }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition };
    }
};

const EditUser = () => {
    const validate = Yup.object({
        name: Yup.string().required('Required'),
        // email: Yup.string().required("Required"),
        phone_no: Yup.string()
            .matches(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4,5}$/, "Your phone number format must be '+1 233-343-2342'")
            .required('Required'),
        gender: Yup.string(),
        dob: Yup.string(),
        region: Yup.string(),
        status: Yup.string(),
        city: Yup.string()
    });

    const [data, setData] = useState();
    const { getToken } = useAuth();
    const navigate = useNavigate();
    const [selectedProvince, setSelectedProvince] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [cities, setCities] = useState([]);
    const { state } = useLocation();

    useEffect(() => {
        if (state?.commuter_id) {
            getCommuterDetail(state?.commuter_id);
        }
    }, []);

    const getCommuterDetail = async (id = '') => {
        const token = getToken();
        if (token && id) {
            new WebApiCalls()
                .getSingleCommuter(token, id)
                .then((res) => {
                    setData(res);
                    const cities = getCities(ProvinceData, res.region);
                    //set cities for dropdown
                    setCities(cities);
                    //set selected city
                    setSelectedCity(() => {
                        for (let city in cities) {
                            if (res.city === cities[city]) return cities[city];
                        }
                    });
                })
                .catch((err) => {});
        }
    };

    const handleSubmit = async (values, actions) => {
        // e.preventDefault()

        // return
        const id = state?.commuter_id;
        const token = getToken();
        if (token && id) {
            const obj = {
                name: values.name,
                // email: values.email,
                gender: values.gender,
                phone_no: values.phone_no,
                dob: values.dob,
                status: values?.status,
                region: values?.region,
                city: values?.city
            };
            await new WebApiCalls()
                .updateCommuter(token, obj, id)
                .then((res) => {
                    if (res?.code == 200) {
                        toast.success('Commuter has been updated successfully.');
                        navigate('/commuters');
                    } else {
                        toast.error('Oops...! Something went wrong');
                    }
                })
                .catch((err) => {
                    console.log('Error here:    ', err);
                });
        }
    };
    return (
        <>
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={8} lg={11} className="shadow-lg p-5 m-3">
                    <Formik
                        initialValues={{
                            name: data?.name,
                            // email: userEmail,
                            phone_no: data?.phone_no,
                            dob: moment(data?.dob).format('YYYY-MM-DD'),
                            city: data?.city || '',
                            gender: data?.gender || '',
                            status: data?.status || '',
                            region: data?.region || ''
                        }}
                        validationSchema={validate}
                        onSubmit={handleSubmit}
                        enableReinitialize={true}
                    >
                        {(formik) => (
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    formik.handleSubmit();
                                }}
                            >
                                <Row>
                                    <Col xs={12} sm={12} md={11} lg={6} className="mb-2">
                                        <FormField
                                            value={formik.values.name}
                                            onChange={formik.handleChange}
                                            className="form-control common-input"
                                            label="Name"
                                            name="name"
                                            type="text"
                                            placeholder="Enter name"
                                        />
                                    </Col>

                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <label>Status</label>
                                        <Field
                                            as="select"
                                            value={formik.values.status}
                                            name="status"
                                            className="status-selector-input"
                                            label="Status"
                                            onChange={formik.handleChange}
                                        >
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </Field>
                                    </Col>

                                    {/* <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                    <FormField value={formik.values.email} onChange={formik.handleChange} className="form-control common-input"
                      label="Email" name="email" type="email"
                      placeholder="Enter email" />
                  </Col> */}
                                </Row>

                                <Row>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <label>Gender</label>
                                        <Field
                                            as="select"
                                            value={formik.values.gender}
                                            name="gender"
                                            className="gender-selector"
                                            label="Gender"
                                            onChange={formik.handleChange}
                                        >
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                        </Field>
                                    </Col>

                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <FormField
                                            value={formik.values.phone_no}
                                            onKeyDown={(e) => {
                                                if (e.target.value.length === 0 && e.key !== 'Backspace') {
                                                    e.target.value = '+' + e.target.value;
                                                }
                                                if (e.target.value.length === 2 && e.key !== 'Backspace') {
                                                    e.target.value = e.target.value + ' ';
                                                }
                                                if (e.target.value.length === 6 && e.key !== 'Backspace') {
                                                    e.target.value = e.target.value + '-';
                                                }
                                                if (e.target.value.length === 10 && e.key !== 'Backspace') {
                                                    e.target.value = e.target.value + '-';
                                                }
                                                formik.setFieldValue('phone_no', e.target.value);
                                            }}
                                            className="form-control common-input"
                                            label="Phone Number"
                                            name="phone_no"
                                            type="text"
                                            placeholder="Enter phone"
                                        />
                                    </Col>

                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <FormField
                                            value={formik.values.dob}
                                            onChange={formik.handleChange}
                                            className="form-control common-input"
                                            label="Date of Birth"
                                            name="dob"
                                            type="date"
                                            placeholder="Date of birth"
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <label>Province/Territory</label>
                                        <Field
                                            as="select"
                                            value={formik.values.region}
                                            name="region"
                                            className="gender-selector"
                                            label="Region"
                                            onChange={(e) => {
                                                const { value } = e.target;
                                                setCities(() => getCities(ProvinceData, value));
                                                formik.setFieldValue('region', value);
                                            }}
                                        >
                                            {ProvinceData.map((province) => {
                                                return <option value={province.provinceName}>{province.provinceName}</option>;
                                            })}
                                        </Field>
                                        {/* <select>
                      
                    </select>
                    <FormField value={formik.values.d_o_b} onChange={formik.handleChange}
                      className="form-control common-input" label="Region" name="d_o_b"
                      type="date" placeholder="Date of birth" /> */}
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
                                        <label>City</label>
                                        <Field as="select" value={formik.values.city} name="city" className="gender-selector" label="city" onChange={formik.handleChange}>
                                            {cities.map((city) => (
                                                <option value={city}>{city}</option>
                                            ))}
                                        </Field>
                                    </Col>
                                </Row>

                                <div className="text-end">
                                    <Link to="/commuters">
                                        <Button className="theme-cancel-btn me-3">Cancel</Button>
                                    </Link>
                                    <Button type="submit" className="theme-btn">
                                        Update
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Col>
            </Row>
        </>
    );
};
export default EditUser;
/*

    // const validate = Yup.object({
    //   district: Yup.string().required("Required"),
    //   keeper: Yup.string().required("Required"),
    //   email: Yup.string().email("Email is invalid").required("Required"),
    //   shield: Yup.string().required("Required"),
    // });

    // const keepersData = [
    //   {
    //     label: "Bro. Maceo raieiy",
    //     value: "maceo"
    //   },
    //   {
    //     label: "Qasim Khan",
    //     value: "qasim"
    //   },
    //   {
    //     label: "waqas Khan",
    //     value: "waqas"
    //   },
    //   {
    //     label: "Hamza",
    //     value: "hamza"
    //   },
    // ]

    // return (
    //   <>
    //     <Row className="d-flex justify-content-center">
    //       <Col xs={12} sm={12} md={8} lg={6} className="shadow-lg p-3 m-3">
    //         <Formik
    //           initialValues={{
    //             district: "1021",
    //             keeper: "Qasim Khan",
    //             email: "qasim@ropstam.com",
    //             shield: "sheild data",
    //           }}
    //           validationSchema={validate}
    //           onSubmit={(values) => {
    //             console.log("District Values", values);
    //           }}
    //         >
    //           {(formik) => (
    //             <Form>
    //               <FormField
    //                 label="District Number"
    //                 name="district"
    //                 type="text"
    //               />
    //               <FormSelect label="Keepers" name="keeper" data={keepersData} />
    //               <FormField label="Email Address" name="email" type="email" />
    //               <FormField
    //                 label="Theme Shield Upload"
    //                 name="shield"
    //                 type="text"
    //               />
    //               <div className="text-end">
    //                 <Link to="/districts"><Button type="submit" className="theme-cancel-btn me-3">
    //                   Cancel
    //                 </Button></Link>
    //                 <Button type="submit" className="theme-btn">
    //                   Update
    //                 </Button>
    //               </div>
    //             </Form>
    //           )}
    //         </Formik>
    //       </Col>
    //     </Row>
    //   </>
    // );
    */
